
import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { SIGN_OUT } from "../store/action-types";
import User from "../entities/User";

@Component
export default class TopBar extends Vue {
  @Getter("auth/user") user: User;

  @Action(`auth/${SIGN_OUT}`) doSignOut: () => Promise<void>;

  get userEmail(): string {
    return this.user?.email || "";
  }

  async signOut() {
    await this.doSignOut();
    this.$router.replace({ name: "sign-in" });
  }
}
